module.exports = [{
      plugin: require('C:/Users/rafae/Downloads/youfirst-insurance-master/youfirst-insurance-master/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
